module.exports = __webpack_public_path__ + "static/media/22.0d43059f.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/shoes/22.png
// module id = 1063
// module chunks = 0